var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFlagBanner = function SvgIconFlagBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.75 4.5a1 1 0 0 1 1-1H21a1 1 0 0 1 .78 1.625l-4 5 4 5A1 1 0 0 1 21 16.75H4.75v3.5a1 1 0 1 1-2 0zm2 10.25h14.17l-3.2-4a1 1 0 0 1 0-1.25l3.2-4H4.75z",
    clipRule: "evenodd"
  })));
};
export default SvgIconFlagBanner;